import { Pipe, PipeTransform } from '@angular/core';

import { IConsequenceType, IPbisType } from 'libs/domain';

import { PastAssignment } from '../types/tt-my-class.types';

@Pipe({
  name: 'areActionsAssigned',
  pure: false,
})
export class AreActionsAssignedPipe implements PipeTransform {
  transform(actionsMap: Map<string, PastAssignment[]>, type: 'praise' | 'guidance'): boolean {
    if (!actionsMap || actionsMap?.size === 0) {
      return false;
    }

    const targetCategoryId = type === 'praise' ? 0 : 1;

    for (const actions of actionsMap.values()) {
      for (const action of actions) {
        // since we're checking for assignmentType first, we can exclude other data types
        // while avoiding type errors with categoryId
        if (
          action.assignmentType === 'behavior' &&
          (action.data as IConsequenceType | IPbisType)?.categoryId === targetCategoryId
        ) {
          return true;
        }
      }
    }

    return false;
  }
}
